export const GET_SCORECARD_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const GET_SCORECARD_ERROR_MESSAGE =
  "Error in getting ratings, please try again";

export const UPDATE_SCORECARD_ERROR_MESSAGE =
  "Error in updating ratings, please try again";
